/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, March 28th 2022, 9:03:25 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { APIMany2OneSelectFormInput, APIMany2OneEditButton, ConcreteAPIMany2OneSelectFormInputProps } from "ui-widgets";
import { FormConfiguration, FormAPIFilters } from "lib/schemas";
import { APISERVICEPATHS } from "lib/api";
import { FileText as FileTextIcon } from "react-feather";
import { COLORSCHEME } from "theme/styles";
import { useFormBuilderContext } from "form-builder/providers";
import { useOSFormContext } from "ui-widgets/forms/providers";

interface FormMany2OnePickerProps<TPrimaryObject>
  extends ConcreteAPIMany2OneSelectFormInputProps<TPrimaryObject, FormConfiguration> {
  apiQueryParams?: FormAPIFilters;
}

export const FormMany2OnePicker = <TPrimaryObject,>(props: FormMany2OnePickerProps<TPrimaryObject>) => {
  const { formId, navigateToForm } = useFormMany2OnePicker(props.schema_field_key);

  return (
    <APIMany2OneSelectFormInput<TPrimaryObject, FormConfiguration>
      label={props.label ?? "Form"}
      itemIdProperty="id"
      getOptionLabel={(option) => option.title}
      loadingText="Loading Forms"
      apiServicePath={APISERVICEPATHS.forms}
      inputStartAdornment={<FileTextIcon color={COLORSCHEME.primary} />}
      inputEndAdornment={<APIMany2OneEditButton objectId={formId} onClick={navigateToForm} />}
      {...props}
    />
  );
};

const useFormMany2OnePicker = <TPrimaryObject,>(
  schema_field_key: ConcreteAPIMany2OneSelectFormInputProps<TPrimaryObject, FormConfiguration>["schema_field_key"]
) => {
  const { watch } = useOSFormContext<TPrimaryObject>();

  const formId = watch<any>(schema_field_key) as FormConfiguration["id"];

  const { useNavigateToFormBuilder } = useFormBuilderContext();
  const { navigateToFormBuilder } = useNavigateToFormBuilder();

  const navigateToForm = () => navigateToFormBuilder(formId);

  return { formId, navigateToForm };
};
